import React, { Fragment, useState, useEffect, useRef } from "react";
// import Navbar2 from "../../components/Navbar2";
// import Hero3 from "../../components/hero3";
// import ServiceSection from "../../components/ServiceSection2";
// import About from "../../components/about";
// import FunFact from "../../components/FunFact";
// import TeamSection from "../../components/team";
// import Testimonial from "../../components/Testimonial";
// import PricingSection from "../../components/PricingSection";
// import PartnerSection from "../../components/PartnerSection";
// import BlogSection from "../../components/BlogSection";
// import BlogHomePage from "../../components/BlogHomePage";
// import ProjectSection from "../../components/ProjectSection";
// import Scrollbar from "../../components/scrollbar";
// import Footer from "../../components/footer";

import NewNavbar from "../../new-components/NewNavbar";
import NewHero from "../../new-components/NewHero";
import NewHomeEvent from "../../new-components/NewHomeEvent";
import NewAbout from "../../new-components/NewAbout";
import NewCoaching from "../../new-components/NewCoaching";
import NewSamples from "../../new-components/NewSamples";
import NewEvents from "../../new-components/NewEvents";
import NewTestimonials from "../../new-components/NewTestimonials";
import NewWellnews from "../../new-components/NewWellnews";
import NewFooter from "../../new-components/NewFooter";
import NewScrollTop from "../../new-components/NewScrollTop";
import NewLoading from "../../new-components/NewLoading";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import BreathBanner from "../../new-components/BreathBanner";

const HomePage = () => {
  const [loading, setLoading] = useState(false);
  const readyRef = useRef(false);

  useEffect(() => {
    // Page is ready almost immediately
    const readyTimer = setTimeout(() => {
      readyRef.current = true;
    }, 100);

    // Show loading spinner only if page takes >5s to load
    const loadTimer = setTimeout(() => {
      if (!readyRef.current) setLoading(true);
    }, 5000);

    return () => {
      clearTimeout(loadTimer);
      clearTimeout(readyTimer);
    };
  }, []);

  if (loading) {
    return <NewLoading />;
  }

  return (
    <Fragment>

      {/* <Navbar2 hclass={"wpo-header-style-2"} topbarBlock={"topbar-block"} />
      <Hero3 /> */}
      {/* <ServiceSection /> */}
      {/* <About /> */}
      {/* <FunFact /> */}
      {/* <ProjectSection /> */}
      {/* <TeamSection /> */}
      {/* <Testimonial /> */}
      {/* <PricingSection /> */}
      {/* <PartnerSection /> */}
      {/* <BlogHomePage /> */}
      {/* <BlogSection /> */}
      {/* <Footer />
      <Scrollbar /> */}

      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />
      <NewHero />
      <NewHomeEvent />
      <NewAbout />
      <NewCoaching />
      <NewSamples />
      <BreathBanner />
      <NewEvents />
      <NewTestimonials />
      <NewWellnews />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};

export default HomePage